import { useLocation, useNavigate } from "react-router-dom";
import { getUser } from "../../../utils/storage";
import AdminSidebar from "../../../components/AdminSidebar";
import RentedDevices from "./RentedDevices";
import RentDevices from "./RentDevices";
import InactiveRentals from "./InactiveRentals";

export default function Rentals() {
  const user = getUser();
  const location = useLocation();
  const navigate = useNavigate();

  const tabs = [
    { name: "Rented Devices", href: "/admin/stock/rented" },
    { name: "Rent Devices", href: "/admin/stock/rent" },
    { name: "Inactive Rentals", href: "/admin/stock/inactive-rentals" },
  ];

  return (
    <AdminSidebar>
      <div className="px-4 sm:px-6 lg:px-8 bg-bgBlue">
        <div className="sm:flex flex-col sm:items-start">
          <div className="w-full flex justify-between py-4 px-4 bg-white rounded-lg">
            <h3 className="font-bold text-2xl">👋 Hello {user.name}</h3>
          </div>
        </div>

        {/* <div className="mt-4 flex space-x-4">
          {tabs.map((tab) => (
            <button
              key={tab.name}
              onClick={() => navigate(tab.href)}
              className={`px-4 py-2 text-sm font-medium rounded-md shadow-sm transition-colors duration-200 ${
                location.pathname.includes(tab.href)
                  ? "bg-bluePrimary text-white"
                  : "bg-white text-gray-700 hover:bg-gray-50 border border-gray-200"
              }`}
            >
              {tab.name}
            </button>
          ))}
        </div> */}

        <div className="mt-8 bg-white rounded-lg">
          {location.pathname.includes("/admin/stock/rented") && <RentedDevices />}
          {location.pathname === "/admin/stock/rent" && <RentDevices />}
          {location.pathname === "/admin/stock/inactive-rentals" && <InactiveRentals />}
        </div>
      </div>
    </AdminSidebar>
  );
}
